/**
 * Lookup region for a country.
 */
export const COUNTRY_REGION = {
  'au' : 'au',
  'cc' : 'au',
  'cx' : 'au',
  'fj' : 'au',
  'nc' : 'au',
  'nf' : 'au',
  'pg' : 'au',
  'sb' : 'au',
  'vu' : 'au',
  'bd' : 'bd',
  'fk' : 'uk',
  'gb' : 'uk',
  'gg' : 'uk',
  'gi' : 'uk',
  'gs' : 'uk',
  'im' : 'uk',
  'io' : 'uk',
  'je' : 'uk',
  'sh' : 'uk',
  'uk' : 'uk',
  'bt' : 'in',
  'in' : 'in',
  'np' : 'in',
  'lk' : 'lk',
  'mv' : 'lk',
  'as' : 'nz',
  'ck' : 'nz',
  'nu' : 'nz',
  'nz' : 'nz',
  'pf' : 'nz',
  'pn' : 'nz',
  'tk' : 'nz',
  'to' : 'nz',
  'tv' : 'nz',
  'wf' : 'nz',
  'ws' : 'nz',
  'af' : 'pk',
  'pk' : 'pk',
  'pr' : 'us',
  'um' : 'us',
  'us' : 'us',
  'ww' : 'ww',
  'bw' : 'za',
  'ls' : 'za',
  'mg' : 'za',
  'mw' : 'za',
  'mz' : 'za',
  'na' : 'za',
  'sz' : 'za',
  'za' : 'za',
  'zm' : 'za',
  'zw' : 'za'
}



// WEBPACK FOOTER //
// ../app/constants/countryToRegion.js